import "./excalidraw-env"; // must precede any module that imports @excalidraw/excalidraw
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./excalidraw.css";
import "./styles.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
